import update from 'immutability-helper';
import * as types from './types';

const initialState = {
  response: [], // all ai and ei dimensions in exp-insights
  errorCode: 0,
  errorMsg: '',
  isFetching: true,
};

const switchMap = {};

switchMap[types.INIT] = () => ({
  ...initialState,
});

switchMap[types.FETCHING] = state => update(state, {
  isFetching: {
    $set: true,
  },
});

switchMap[types.FETCHING_SUCCESS] = (state, action) => update(state, {
  $merge: {
    response: action.response,
    isFetching: false,
    errorCode: 0,
    errorMsg: '',
  },
});

export default (state = initialState, action) => (
  switchMap[action.type]
    ? switchMap[action.type](state, action)
    : state
);
